import { useQuery } from '@tanstack/react-query';
import { paymentApi } from '../services/paymentApi';
import type { PaymentStatus } from '../types/payments';
import { useHybridAuth } from './useHybridAuth';

export function usePaymentStatus(
  dispatchId: string | undefined,
  companyId: string | undefined,
) {
  const { getAccessTokenSilently, isAuthenticated } = useHybridAuth();
  const isEnabled = !!dispatchId && !!companyId && isAuthenticated;
  
  return useQuery<PaymentStatus>({
    queryKey: ['payment-status', dispatchId || null, companyId || null],
    queryFn: async () => {
      if (!dispatchId || !companyId) {
        throw new Error('Dispatch ID and Company ID are required');
      }
      // Get auth token and pass it to the API call
      const token = await getAccessTokenSilently();
      return paymentApi.getPaymentStatus(dispatchId, companyId, token);
    },
    enabled: isEnabled,
    staleTime: 30 * 1000, // 30 seconds
    gcTime: 5 * 60 * 1000, // 5 minutes (was cacheTime)
    retry: 2,
  });
}

